var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[(_vm.dataset)?_c('v-col',{attrs:{"cols":"10","lg":"6"}},[_c('Planning',{staticClass:"mt-5",attrs:{"tasksCompleted":_vm.dataset,"modeEdit":true},on:{"next":_vm.savePlanning}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }